export const snackId = 'order-status-snack-id';

export const orderStatusSnackIdRegexp = new RegExp(`^${snackId}`);
